if (!customElements.get('sportshub-header-search')) {
  customElements.define('sportshub-header-search', class extends HTMLElement {
    constructor() {
      super();
      this.desktop = window.matchMedia('(min-width: 990px)');
      this.onBreakpoint = () => {
        if (!this.desktop.matches) this.querySelector('predictive-search')?.close();
      };
      this.addEventListener('keyup', (event) => {
        if (event.key === 'Escape') {
          event.stopPropagation();
          this.querySelector('predictive-search')?.close();
        }
      });
    }

    connectedCallback() {
      this.desktop.addEventListener('change', this.onBreakpoint);
    }

    disconnectedCallback() {
      this.desktop.removeEventListener('change', this.onBreakpoint);
    }
  });
}
